export function authFailureAction(status) {
  return status === 401 || status === 403 ? 'signout' : 'retry';
}
